
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { getUuid } from "@common/src/utils/common";
import t from "@common/src/i18n/t";
import Cropper from "../img-cropper/index.vue";
const base = namespace("base");

@Component({
  model: {
    prop: "fileUrls",
    event: "change"
  },
  components: {
    Cropper
  }
})
export default class FileUpload extends Vue {
  @base.Action getUploadToken;
  @Prop({ default: 1 })
  maxNum: number;

  @Prop({ default: "image" }) // image video
  fileType: string;

  @Prop({ default: () => [] })
  defaultFileList: any;

  @Prop({ default: false, type: Boolean })
  readonly: boolean;

  @Prop({ default: () => [] })
  fileUrls: any;
  // 文件大小限制 单位KB 0为不限制
  @Prop({ default: 0 })
  limitSize: Number;

  @Prop({
    default: () => ({ businessCode: "defalut", businessType: "4" })
  })
  uploadBusinessInfo: any;

  @Prop({
    default: false,
    type: Boolean
  })
  cut: boolean;

  @Prop({
    default: () => ({
      autoCropWidth: 1125,
      autoCropHeight: 612
    }),
    type: Object
  })
  cutOption: any;

  isLoading: boolean = false;
  cropperVisible = false;
  get allUrl() {
    return this.fileList.map(item => item.url);
  }
  uploadUrl: string = "";
  uploadTokenObj: any = {};
  fileList: any = [];
  cutImage: any = {
    url: "",
    index: ""
  };
  uploadFileCb(file) {
    return this.getUploadToken({
      businessType: "0",
      businessCode: "000000000"
    }).then(data => {
      const fileSuffix = file.name.split(".")[1] || "";
      this.uploadTokenObj = {
        url: data.data.host,
        key: `${data.data.dir}/${getUuid(15)}.${fileSuffix}`,
        // key: `${data.data.dir}/${getUuid(15)}/${file.name}`,
        policy: data.data.policy,
        OSSAccessKeyId: data.data.accessId,
        Signature: data.data.signature,
        success_action_status: 200,
        domain: data.data.domain
      };
      this.uploadUrl = data.data.host;
    });
  }
  async beforeAvatarUpload(file) {
    if (this.fileType === "video" && file.type !== "video/mp4") {
      this.$message.warning(t("v210801.only-support-pm4"));
      return;
    }
    const fileSizeKb = file.size / 1024;
    if (this.limitSize && fileSizeKb > this.limitSize) {
      this.$message.warning(t("v213.file-size-cannot-exceed") + this.limitSize + "KB");
      return;
    }
    this.isLoading = true;
    await this.uploadFileCb(file);
  }
  handleUploadSuccess(response, file) {
    console.log(file);
    if (file.status === "success") {
      // getUuid(15)
      this.fileList.push({
        name: file.name,
        url: this.uploadTokenObj.domain + "/" + this.uploadTokenObj.key
      });
      this.emitChange("upload");
      this.isLoading = false;
    }
  }
  handleDeleteImg(i) {
    this.fileList.splice(i, 1);
    this.emitChange();
  }
  emitChange(type?) {
    if (this.maxNum <= 1) {
      if (this.fileList.length > 0) {
        const url = this.fileList[0].url;
        this.$emit("change", url);
        if (type === "upload") {
          this.$emit("uploadSuccess", url);
        }
      } else {
        this.$emit("change", "");
      }
    } else {
      this.$emit(
        "change",
        this.fileList.map(item => item.url)
      );
      if (type === "upload") {
        this.$emit("uploadSuccess");
      }
    }
  }
  @Watch("defaultFileList", {
    immediate: true
  })
  watchDefaultFileList(val, oldQuestion) {
    // 防止死循环
    if (val && oldQuestion && val.toString() === oldQuestion.toString()) {
      return;
    }
    if (val.length) {
      val.forEach(item => {
        if (item.url && !this.allUrl.includes(item.url)) {
          console.log("[ this.fileList ]", this.fileList);
          this.fileList.push(item);
          this.emitChange();
        }
      });
    } else {
      this.fileList = [];
      this.emitChange();
    }
  }
  cutImg(file, index) {
    this.cropperVisible = true;
    this.cutImage.url = file.url;
    this.cutImage.index = index;
  }
  closeVisible(flag) {
    this.cropperVisible = flag;
  }
  getCropperImg(fileObj) {
    console.log(fileObj);
    this.fileList.splice(this.cutImage.index, 1, {
      name: fileObj.name,
      url: fileObj.url
    });
    this.emitChange();
  }
  clearFile() {
    this.fileList = [];
    this.uploadUrl = "";
    this.emitChange();
  }
  // ////
}
